import currencyCodes from '@/assets/currency-codes'

export const getCurrencyName = code =>
  currencyCodes.find(x => x.code === code).name
